var BOLD = BOLD || {};
BOLD.helpers = BOLD.helpers || {};

BOLD.helpers.setupCalculationField = function setupCalculationField(calculation_obj){
    var input_obj_arr = calculation_obj.inputs, target_id = calculation_obj.target_id, calculation = calculation_obj.formula;
    if(typeof calculation !== 'function' || !target_id) return;
    
    BOLD.options.app.on('option_changed', function(a){
      if(!a.data.source_input) return;

      var key = a.data.option_key;
      var affects_total = false;
      for(var i=0; i<input_obj_arr.length; i++){
        if (key == input_obj_arr[i].id){
          affects_total = true;
          break;
        }
      }
      if(!affects_total) return;
      
      var form = a.data.source_input.form;
      if(!form) return;
      
      form.querySelector('.minus_btn').setAttribute('style', 'pointer-events:none');
      form.querySelector('.plus_btn').setAttribute('style', 'pointer-events:none');
      
      if(calculation_obj.force_parent_checked){
        var parent_field = BOLD.helpers.getInputFieldByOptionId(calculation_obj.parent_id, a.data.option_product);
        if(parent_field && parent_field.checked == false){
          parent_field.checked = true;
          parent_field.disabled = true;
          BOLD.helpers.dom.trigger('change', parent_field);
        }
      }
      
      var target_field = BOLD.helpers.getInputFieldByOptionId(target_id, a.data.option_product);
      if(!target_field) return;
      target_field.setAttribute('readonly', true);
      target_field.value = calculation(BOLD.helpers.getCalculationValues(input_obj_arr, a.data, form));
      BOLD.helpers.dom.trigger('change', target_field);
    
    });
  
  };
  
  BOLD.helpers.getCalculationValues = function getCalculationValues(input_obj_arr, data, form){
    var input_values = {};
    
    for(var i=0; i < input_obj_arr.length; i++){
      var value;
      var key = input_obj_arr[i].id;
      
      var input_field = BOLD.helpers.getInputFieldByOptionId(key, data.option_product);

      if(input_field){
        value = input_field.value;
        if(!isNaN(parseInt(value)) && parseInt(value) == parseFloat(value)){
          value = parseInt(value);
        }
      }else{
        value = null;
      }
      input_values[input_obj_arr[i].name]=value;
    }
    return input_values;
  }
  
  BOLD.helpers.getInputFieldByOptionId = function getInputFieldByOptionId(id, option_product){
    var form = option_product.form;
    if(id==='quantity')
      return form.quantity;
    
    return(form ? form.getElementsByClassName(id)[0] : null);
  }
  
  
  
  /*
  //This is a sample calculation object that doesn't affect an editable quantity set
  
  var calc1 = {
    inputs: [
      {name:'head_circ', id:'nb_319013_166015'},
      {name:'height', id:'nb_319016_166015'},
      {name:'length', id:'nb_319014_166015'}
    ],
    target_id: 'nb_319021_166015',
    formula: function(values){
      return Math.round((Math.pow((values.head_circ / Math.PI) * 0.5, 3) * 4.0/3.0 * Math.PI) + (Math.PI * 4.0/3.0 * (2 * values.height * 0.5) * (values.length * 0.5)  ));
    }
  };
  setupCalculationField(calc1);
  


  //This is a sample caculation object that does affect an editable quantity set
  var calc2 = {
    inputs: [
      {name: 'volume', id: 'nb_319021_166015'}
    ],
    target_id: 'qty_319214_166015_11047855',
    //TODO: Handle select boxes that have editable quantity set
    force_parent_checked: true,
    
    //TODO: Dynamically get the parent ID so that we don't have to get the extra value
    parent_id: 'cb_319214_166015',
    
    formula: function(values){
      return Math.round(Math.sqrt(values.volume));
    }
  };
  setupCalculationField(calc2);

*/